import React from "react";

const ErrorPage = () => {
  return <div className="container">{/* <h2>Go Back</h2> */}</div>;
};

export default ErrorPage;
